<template>
  <v-container class="p-calculator">
    <v-form ref="form" lazy-validation>
      <v-layout>
        <v-flex shrink pa-1 pr-5>
          <p>累计预扣预缴个税计算器2019</p>
          <v-select
            v-model="form.select"
            :items="months"
            class="form-item"
            label="纳税期数"
            @change="monthSelected"
          ></v-select>
          <v-text-field
            v-model="form.income"
            class="form-item"
            label="本月工资"
            placeholder="0"
            @change="incomeChange"
          ></v-text-field>
          <v-text-field v-model="form.incomeAll" class="form-item" placeholder="0" label="累计"></v-text-field>
          <v-text-field
            v-model="form.insure"
            class="form-item"
            label="各项社会保险费"
            placeholder="0"
            @change="insureChange"
          ></v-text-field>
          <v-text-field v-model="form.insureAll" class="form-item" placeholder="0" label="累计"></v-text-field>
          <v-text-field
            v-model="form.zxfj"
            class="form-item"
            label="专项附加扣除"
            placeholder="0"
            @change="zxfjChange"
          ></v-text-field>
          <v-text-field v-model="form.zxfjAll" class="form-item" placeholder="0" label="累计"></v-text-field>
        </v-flex>
        <v-flex grow pa-1>
          <!-- <v-input label="应纳税所得额">{{ form.salary }}</v-input> -->
          <p>个人所得税计算结果</p>
          <v-text-field v-model="form.lblTaxableIncome" class="form-item" label="应纳税所得额" disabled></v-text-field>
          <v-text-field v-model="form.lblTaxRate" class="form-item" label="适用税率" disabled></v-text-field>
          <v-text-field v-model="form.lblQuick" class="form-item" label="速算扣除数" disabled></v-text-field>
          <v-text-field v-model="form.txtTaxAll" class="form-item" label="累计应缴税款" readonly></v-text-field>
          <v-text-field v-model="form.txtTaxAlready" class="form-item" label="已缴税款" readonly></v-text-field>
          <v-text-field v-model="form.txtTax" class="form-item" label="应补（退）税款" readonly></v-text-field>
          <v-text-field v-model="form.txtRealIncome" class="form-item" label="本月税后收入" readonly></v-text-field>
        </v-flex>
      </v-layout>

      <v-btn class="btn1" @click="submit">计算</v-btn>
      <v-btn class="btn2" @click="reset">重置</v-btn>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      // valid: true,
      // nameRules: [v => !!v || "required"],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      selectmonth: "",
      form: {
        select: null,
        salary: 0,
        income: "", //本月工资
        incomeAll: "", //累计
        insure: "", //各项社会保险费
        insureAll: "", //累计
        zxfj: "", //专项附加扣除
        zxfjAll: "", //累计
        lblTaxableIncome: "", //应纳税所得额
        lblTaxRate: "0%", //适用税率
        lblQuick: "", //速算扣除数
        txtTaxAll: "", //累计应缴税款
        txtTaxAlready: "", //已缴税款
        txtTax: "", //应补（退）税款
        txtRealIncome: "" //本月税后收入
      }
    };
  },
  watch: {
    months: function(m) {
      this.monthSelected(m);
    },
    "form.income": function() {
      this.incomeChange();
    },
    "form.insure": function() {
      this.insureChange();
    },
    "form.zxfj": function() {
      this.zxfjChange();
    }
  },
  methods: {
    monthSelected(m) {
      this.selectmonth = m;
      this.form.incomeAll = Math.round(Number(this.form.income) * Number(m));
      // console.log("monthSelected:"+this.selectmonth);
      // this.$options.methods.incomeChange(m);
      if (this.form.insure > 0 || this.form.insure != "") {
        this.form.insureAll = Math.round(Number(this.form.insure) * Number(m));
      }
      if (this.form.zxfj > 0 || this.form.zxfj != "") {
        this.form.zxfjAll = Math.round(Number(this.form.zxfj) * Number(m));
      }
    },
    incomeChange() {
      this.form.incomeAll = Math.round(
        Number(this.form.income) * Number(this.selectmonth)
      );
    },
    insureChange() {
      this.form.insureAll = Math.round(
        Number(this.form.insure) * Number(this.selectmonth)
      );
    },
    zxfjChange() {
      this.form.zxfjAll = Math.round(
        Number(this.form.zxfj) * Number(this.selectmonth)
      );
    },
    submit_all_index: function(A) {
      let R,
        Q = 0;
      if (A <= 36000) {
        R = 0.03;
        Q = 0;
      } else if (A > 36000 && A <= 144000) {
        R = 0.1;
        Q = 2520;
      } else if (A > 144000 && A <= 300000) {
        R = 0.2;
        Q = 16920;
      } else if (A > 300000 && A <= 420000) {
        R = 0.25;
        Q = 31920;
      } else if (A > 420000 && A <= 660000) {
        R = 0.3;
        Q = 52920;
      } else if (A > 660000 && A <= 960000) {
        R = 0.35;
        Q = 85920;
      } else {
        R = 0.45;
        Q = 181920;
      }
      return new Array(R, Q);
    },
    submit() {
      // if (this.$refs.form.validate()) {
      this.clear();
      if (this.selectmonth == "") {
        alert("请选择纳税期数");
        return;
      }
      if (this.form.income == "") {
        alert("无效的本月工资");
        return;
      }
      if (this.form.insure == null) {
        alert("无效的各项社会保险费金额");
        return;
      }
      if (this.form.zxfj == null) {
        alert("无效的专项附加扣除金额");
        return;
      }
      let lastIncome = Number(this.form.incomeAll) - Number(this.form.income);
      let lastInsure = Number(this.form.insureAll) - Number(this.form.insure);
      let lastZXFJ = Number(this.form.zxfjAll) - Number(this.form.zxfj);
      let baseLine = 5000;
      //calc___A
      let taxableIncome =
        Number(this.form.incomeAll) -
        Number(this.form.insureAll) -
        Number(this.form.zxfjAll) -
        Number(baseLine) * Number(this.selectmonth);
      let R = 0,
        Q = 0;
      let A = taxableIncome;
      A = A.toFixed(2);
      let res = this.$options.methods.submit_all_index(A);
      R = res[0];
      Q = res[1];
      let taxAll = taxableIncome * R - Q;
      taxAll = Math.round(taxAll * 100) / 100;

      //calc___A2
      let R2 = 0,
        Q2 = 0,
        lastTaxAll = 0;
      let lastTaxableIncome = 0;
      if (this.selectmonth > 1) {
        lastTaxableIncome =
          lastIncome -
          lastInsure -
          lastZXFJ -
          baseLine * (this.selectmonth - 1);
        let A2 = lastTaxableIncome;
        A2 = A2.toFixed(2);
        res = this.$options.methods.submit_all_index(A2);
        R2 = res[0];
        Q2 = res[1];
        lastTaxAll = lastTaxableIncome * R2 - Q2;
        lastTaxAll = Math.round(lastTaxAll * 100) / 100;
      }

      let tax = taxAll - lastTaxAll;
      tax = Math.round(tax * 100) / 100;
      let taxTmp = tax > 0 ? tax : 0;
      let realIncome = this.form.income - this.form.insure - taxTmp;
      realIncome = Math.round(realIncome * 100) / 100;

      this.form.lblTaxableIncome = taxableIncome.toFixed(2);
      this.form.lblTaxRate = R * 100 + "%";
      this.form.lblQuick = Q;
      this.form.txtTaxAll = taxAll;
      this.form.txtTaxAlready = lastTaxAll;
      this.form.txtTax = tax;
      this.form.txtRealIncome = realIncome;
      // }
    },
    reset() {
      // this.$refs.form.reset();
      this.form.select = null;
      this.form.income = "";
      this.form.incomeAll = "";
      this.form.insure = "";
      this.form.insureAll = "";
      this.form.zxfj = "";
      this.form.zxfjAll = "";
      this.clear();
    },
    clear() {
      this.form.lblTaxableIncome = 0;
      this.form.lblTaxRate = "0%";
      this.form.lblQuick = 0;
      this.form.txtTaxAll = "";
      this.form.txtTaxAlready = "";
      this.form.txtTax = "";
      this.form.txtRealIncome = "";
    }
  }
};
</script>
<style lang="scss">
.p-calculator {
  .v-menu__content {
    top: 10px !important;
    left: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.p-calculator {
  max-width: 800px;
  .form-item {
    width: 250px;
  }
  button {
    color: #ffffff;
  }
  .btn1 {
    background-color: #1867c0 !important;
  }
  .btn2 {
    background-color: #ff5252 !important;
  }
}
</style>

